import 'moment/locale/hu';
import 'moment/locale/nl';
import 'moment/locale/pl';
import 'moment/locale/ro';
import 'moment/locale/de';
import 'moment/locale/uk';
import 'moment/locale/bg';
import 'moment/locale/it';
import 'moment/locale/cs';
import 'moment/locale/fr';
import 'moment/locale/pt';
import 'moment/locale/ru';
import 'moment/locale/sr';
import 'moment/locale/sk';
import 'moment/locale/es';
import 'moment/locale/tr';
import 'moment/locale/en-gb';
import localeEnglish from 'antd/es/date-picker/locale/en_US';
import localeHungarian from 'antd/es/date-picker/locale/hu_HU';
import localeDutch from 'antd/es/date-picker/locale/nl_NL';
import localePoland from 'antd/es/date-picker/locale/pl_PL';
import localeRomania from 'antd/es/date-picker/locale/ro_RO';
import localeGerman from 'antd/es/date-picker/locale/de_DE';
import localeUkrainian from 'antd/es/date-picker/locale/uk_UA';
import localeBulgarian from 'antd/es/date-picker/locale/bg_BG';
import localeItalian from 'antd/es/date-picker/locale/it_IT';
import localeCzech from 'antd/es/date-picker/locale/cs_CZ';
import localeFrench from 'antd/es/date-picker/locale/fr_FR';
import localePortuguese from 'antd/es/date-picker/locale/pt_PT';
import localeRussian from 'antd/es/date-picker/locale/ru_RU';
import localeSerbian from 'antd/es/date-picker/locale/sr_RS';
import localeSlovak from 'antd/es/date-picker/locale/sk_SK';
import localeSpanish from 'antd/es/date-picker/locale/es_ES';
import localeTurkish from 'antd/es/date-picker/locale/tr_TR';
import localeEnglishGB from 'antd/es/date-picker/locale/en_GB';
import { PickerLocale } from 'antd/es/date-picker/generatePicker';

export const datePickerMapLocales = (currentLang: string): PickerLocale => {
  switch (currentLang) {
    case 'hu':
      return localeHungarian;
    case 'nl-NL':
      return localeDutch;
    case 'pl':
      return localePoland;
    case 'ro':
      return localeRomania;
    case 'de':
      return localeGerman;
    case 'uk':
      return localeUkrainian;
    case 'bg':
      return localeBulgarian;
    case 'it':
      return localeItalian;
    case 'cs':
      return localeCzech;
    case 'fr':
      return localeFrench;
    case 'pt':
      return localePortuguese;
    case 'ru':
      return localeRussian;
    case 'sr':
      return localeSerbian;
    case 'sk':
      return localeSlovak;
    case 'es-ES':
      return localeSpanish;
    case 'tr-TR':
      return localeTurkish;
    case 'en-GB':
      return localeEnglishGB;
    default:
      return localeEnglish;
  }
};
